import {
  createContext,
  useReducer,
  useCallback,
  useContext,
} from 'react'
import Toast from '../components/toast/Toast'
import { ToastType } from '../components/toast/ToastType'
import { v4 } from 'uuid'

// models
interface ToastInterface {
  id?: string
  title: string
  message: string
  toastType: ToastType
  autoHide: boolean
}

interface ActionInterface {
  type: string
  toast: ToastInterface
}

interface StateInterface {
  toasts: ToastInterface[]
}

const initialToasts: any = {
  toasts: [],
}

//Context
const ToastContext = createContext(initialToasts)

const ToastReducer = (state: StateInterface, action: ActionInterface): any => {
  switch (action.type) {
    case 'ADD_TOAST':
      return { toasts: [...state.toasts, action.toast] }
    case 'REMOVE_TOAST':
      return {
        toasts: state.toasts.filter(
          (toast: ToastInterface) => toast.id !== action.toast?.id
        ),
      }
    default:
      return state
  }
}

const ToastProvider = ({ children }: any) => {
  const [toastState, dispatch] = useReducer(ToastReducer, initialToasts)
  const showToast = useCallback(
    (type: ToastType, title = '', message = '', autoHide = true) => {
      dispatch({
        type: 'ADD_TOAST',
        toast: {
          id: v4(),
          toastType: type,
          title: title,
          message: message,
          autoHide: autoHide,
        },
      })
    },
    []
  )
  return (
    <ToastContext.Provider value={[toastState, dispatch, showToast]}>
      <div className="toast-wrapper">
        {toastState.toasts.map((toast: ToastInterface) => (
          <Toast dispatch={dispatch} key={toast?.id} {...toast} />
        ))}
      </div>
      {children}
    </ToastContext.Provider>
  )
}

export default ToastProvider

export const useToastContext = () => useContext(ToastContext)
